(function () {
  var placeholder = document.querySelector('[data-rlpd-shopify-inbox-src]');

  if (!placeholder) {
    return;
  }

  var scriptSrc = placeholder.getAttribute('data-rlpd-shopify-inbox-src');
  var launchers = document.querySelectorAll('[data-rlpd-shopify-inbox-launcher]');
  var loaded = false;

  function loadShopifyInbox() {
    if (loaded || !scriptSrc) {
      return;
    }

    loaded = true;

    var script = document.createElement('script');
    script.src = scriptSrc;
    script.type = 'text/javascript';
    script.defer = true;
    script.addEventListener('load', function () {
      launchers.forEach(function (launcher) {
        launcher.hidden = true;
      });
    });
    document.head.appendChild(script);
  }

  launchers.forEach(function (launcher) {
    launcher.addEventListener('click', function () {
      launcher.setAttribute('aria-busy', 'true');
      loadShopifyInbox();
    });
  });
})();
